const products = [
  {
    name: "Outdoor Stair Lifts",
    desc: "Weatherproof. Built for gardens, porches & outdoor stairs.",
    price: "From ₹2L",
    img: "https://vingrace.in/wp-content/uploads/2025/12/outdoor-stairlifts-1024x1024.webp",
    link: "https://vingrace.in/acorn-outdoor-stair-lift/",
    span: "",
    badge: "",
  },
  {
    name: "Acorn Superglide 130",
    desc: "Whisper-quiet indoor stair lift. Perfect for straight staircases.",
    price: "From ₹1.55L",
    img: "https://vingrace.in/wp-content/uploads/2025/12/Acorn-Superglide-130-Indoor-1024x1024.webp",
    link: "https://vingrace.in/acorn-superglide-130-stair-lift/",
    span: "",
    badge: "Most Popular",
  },
  {
    name: "Otolift Curved Chair Lift",
    desc: "Custom-made for turns, landings & spiral stairs.",
    price: "From ₹4.5L",
    img: "https://vingrace.in/wp-content/uploads/2025/12/Otolift-curved-stairlifts-1024x1024.webp",
    link: "https://vingrace.in/otolift-curved-chair-lift/",
    span: "",
    badge: "",
  },
  {
    name: "Platinum Ergo Straight Stairlift",
    desc: "Ergonomic design for daily comfort on straight staircases.",
    price: "From ₹2L",
    img: "https://vingrace.in/wp-content/uploads/2025/12/Platinum-Ergo-Straight-Stairlift-1024x1024.webp",
    link: "https://vingrace.in/platinum-ergo-straight-stairlift/",
    span: "",
    badge: "",
  },
  {
    name: "Wheelchair Platform Lift",
    desc: "For offices, hospitals, temples & commercial buildings. Wheelchair users ride between floors independently.",
    price: "From ₹6L",
    img: "https://vingrace.in/wp-content/uploads/2026/01/Garaventa-Artira-Curved-Stair-Lift3-768x768.webp",
    link: "https://vingrace.in/platform-wheelchair-stairlift/",
    span: "sm:col-span-2 lg:col-span-1",
    badge: "For Corporates",
  },
];

export default function ProductsGrid() {
  return (
    <section data-testid="products-section" className="py-16 sm:py-20 bg-stone-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#b22300] mb-3 text-center">Our Solutions</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          Stair Lifts for Home & Commercial
        </h2>
        <p className="mt-3 text-stone-500 text-center max-w-2xl mx-auto">
          From homes to offices, hospitals to hotels — we have the perfect lift for every space
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 sm:gap-5">
          {products.map((p) => (
            <a
              key={p.name}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`product-card-${p.name.toLowerCase().replace(/\s+/g, '-')}`}
              className={`group relative rounded-2xl border border-stone-200 bg-white overflow-hidden hover:shadow-lg hover:-translate-y-1 transition-all duration-300 ${p.span}`}
            >
              {p.badge && (
                <span className={`absolute top-3 right-3 z-10 text-xs font-bold px-2.5 py-1 rounded-full ${p.badge === "For Corporates" ? "bg-blue-600 text-white" : "bg-amber-500 text-stone-900"}`}>
                  {p.badge}
                </span>
              )}
              <div className="aspect-square overflow-hidden bg-stone-100">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="text-lg font-semibold text-stone-900 font-['Outfit']">{p.name}</h3>
                <p className="text-stone-500 text-sm mt-1">{p.desc}</p>
                <p className="text-[#b22300] font-bold text-sm mt-2">{p.price}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
